// extracted by mini-css-extract-plugin
export default {"imageWrapper":"IR-z","hovered":"JR-z","hoverImage":"KR-z","mainImage":"LR-z","imageNoBackground":"MR-z","fullSizeImage":"NR-z"};